module.exports = __webpack_public_path__ + "static/media/la-regular-400.87dab6ff.ttf";